export default {
  audiobook: 75,
  explainer: 150,
  commercial: {
    length: {
      30: 50,
      45: 75,
      60: 100,
      75: 120,
      90: 140,
      105: 160,
      120: 180,
    },
    buyout: {
      online: 300,
      radio: {
        local: 0,
        regional: 300,
        national: 600,
      },
      tv: {
        local: 100,
        regional: 400,
        national: 700,
      },
    },
  },
  video: [
    {
      min: 0,
      max: 100,
      pricePerWord: 0,
      correction: 0,
      fixedFee: 99,
    }, {
      min: 101,
      max: 250,
      pricePerWord: 0.4,
      correction: 100,
      fixedFee: 99,
    }, {
      min: 251,
      max: 750,
      pricePerWord: 0.35,
      correction: 250,
      fixedFee: 159,
    }, {
      min: 751,
      max: 1250,
      pricePerWord: 0.30,
      correction: 750,
      fixedFee: 334,
    }, {
      min: 1251,
      max: 2500,
      pricePerWord: 0.20,
      correction: 1250,
      fixedFee: 484,
    }, {
      min: 2501,
      max: 5000,
      pricePerWord: 0.15,
      correction: 2500,
      fixedFee: 734,
    }, {
      min: 5001,
      max: 10000000,
      pricePerWord: 0.13,
      correction: 5000,
      fixedFee: 1109,
    },
  ],
  ivr: [
    {
      min: 0,
      max: 20,
      fee: 29,
    },
    {
      min: 21,
      max: 50,
      fee: 49,
    },
    {
      min: 51,
      max: 80,
      fee: 79,
    },
    {
      min: 81,
      max: 120,
      fee: 99,
    },
  ],
};
